import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_MAILPUSH = 'REQUEST_FETCH_STATS_MAILPUSH';
export const SUCCESS_FETCH_STATS_MAILPUSH = 'SUCCESS_FETCH_STATS_MAILPUSH';
export const FAIL_FETCH_STATS_MAILPUSH = 'FAIL_FETCH_STATS_MAILPUSH';

export const fetchStatsMailPush = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_MAILPUSH, payload});
    if (onRequest) onRequest(payload);
    fetch(getEndpoint('fetchStatsMailPush', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_MAILPUSH});
        else dispatch({type: SUCCESS_FETCH_STATS_MAILPUSH, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_MAILPUSH) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_MAILPUSH_BY_USER = 'REQUEST_FETCH_MAILPUSH_BY_USER';
export const SUCCESS_FETCH_MAILPUSH_BY_USER = 'SUCCESS_FETCH_MAILPUSH_BY_USER';
export const FAIL_FETCH_MAILPUSH_BY_USER = 'FAIL_FETCH_MAILPUSH_BY_USER';

export const fetchMailPushByUser = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MAILPUSH_BY_USER, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchMailPushByUser', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_MAILPUSH_BY_USER});
        else dispatch({type: SUCCESS_FETCH_MAILPUSH_BY_USER, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_MAILPUSH_BY_USER) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_SEQUENCES = 'REQUEST_FETCH_SEQUENCES';
export const SUCCESS_FETCH_SEQUENCES = 'SUCCESS_FETCH_SEQUENCES';
export const FAIL_FETCH_SEQUENCES = 'FAIL_FETCH_SEQUENCES';

export const fetchSequences = (callbacks, appName) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_SEQUENCES});
    if (onRequest) onRequest();

    fetch(getEndpoint('fetchSequences', appName), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_SEQUENCES});
        else dispatch({type: SUCCESS_FETCH_SEQUENCES, data: data.sequences});

        if (onSuccess) onSuccess(data.sequences);
      })
      .catch((error, type = FAIL_FETCH_SEQUENCES) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/mailPush.js